export const API_BASE_URL = 'https://api.exchangeratesapi.io/api';
export const API_GET_LATEST = '/latest';
